import { render, staticRenderFns } from "./cashrecei.vue?vue&type=template&id=2934d70a&scoped=true&"
import script from "./cashrecei.vue?vue&type=script&lang=js&"
export * from "./cashrecei.vue?vue&type=script&lang=js&"
import style0 from "./cashrecei.vue?vue&type=style&index=0&id=2934d70a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2934d70a",
  null
  
)

export default component.exports